/**
 * @auth 赖传峰
 * @date 2024/4/24
 * @desc 携带了语言标志符的分享链接，为页面设置分享链接中的语言，并 301 到不带语言的分享链接
 * https://mypikpak.com/zh-CN/s/VNZKHpUYWjBxfbI2r5hSHWbUo1 301 to https://mypikpak.com/s/VNZKHpUYWjBxfbI2r5hSHWbUo1 and set locale to zh-CN
 */
import { defineNuxtRouteMiddleware, navigateTo, removeLocaleFromPath, useCookie } from '#imports'
import { StorageKey, SupportLocale } from '~/types/enum'

export default defineNuxtRouteMiddleware(async to => {
  const fullPathWithoutLocale = removeLocaleFromPath(to.fullPath)
  const localeReg = new RegExp(`^/(${Object.values(SupportLocale).join('|')}).*`, 'i')
  if (localeReg.test(to.path) && fullPathWithoutLocale.startsWith('/s/')) {
    useCookie(StorageKey.LOCALE).value = to.fullPath.replace(localeReg, '$1')
    return navigateTo(fullPathWithoutLocale, { redirectCode: 301 })
  }
})
